(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("ExternalUrlPreviewCtrl", ["$scope", externalUrlPreviewCtrl]);
    // ReSharper disable once UnusedParameter
    function externalUrlPreviewCtrl($scope) {
        var vm = this;
        vm.assignment = $scope.$parent.vm.assignment;
        vm.isEmbedded = vm.assignment.specificInfo.displayOptionMode.toLowerCase() === "embedcode";
        vm.modalSize = vm.assignment.specificInfo.modalSize;
        if (!vm.isEmbedded) {
            $scope.$parent.vm.buttons = "goToUrl.tpl";
        }
    }
}());
